import { eq } from "@mojo/db";
import { customerPortalUserTable, customerTable } from "@mojo/db/schema";
import { createServerFn } from "@tanstack/react-start";
import { getRequestHeaders } from "@tanstack/react-start/server";
import { auth, type Session, type User } from "@/lib/auth";
import { db } from "@/lib/db";

export const getSession = createServerFn({ method: "GET" }).handler(
	async (): Promise<Session | null> => {
		const headers = getRequestHeaders();
		const session = await auth.api.getSession({ headers });
		return session;
	},
);

export const signOut = createServerFn({ method: "POST" }).handler(async () => {
	const headers = getRequestHeaders();
	await auth.api.signOut({ headers });
	return { success: true };
});

export type CustomerInfo = {
	name: string;
	logoUrl: string | null;
};

export const getCustomerInfo = createServerFn({ method: "GET" }).handler(
	async (): Promise<CustomerInfo | null> => {
		const headers = getRequestHeaders();
		const session = await auth.api.getSession({ headers });

		if (!session?.user?.id) {
			return null;
		}

		const result = await db
			.select({
				name: customerTable.name,
				logoUrl: customerTable.logoUrl,
			})
			.from(customerPortalUserTable)
			.innerJoin(
				customerTable,
				eq(customerPortalUserTable.customerId, customerTable.id),
			)
			.where(eq(customerPortalUserTable.id, session.user.id))
			.limit(1);

		return result[0] ?? null;
	},
);

export type { Session, User };
